import { ReboundOrder, ReturnsOrder } from '../types'
import { ZReturnsOrder } from '../validators/returnSchema'
import { mappedReboundApiToReturn } from '../mappers/mappedReboundApiToReturn'
import trackError from '@helpers/trackError'
import { formatZodError } from './zodErrorFormatter'

export async function mapReboundToReturn(
  reboundOrder: ReboundOrder
): Promise<ReturnsOrder> {
  const mappedReturn = await mappedReboundApiToReturn(reboundOrder)

  const validatedReturn = ZReturnsOrder.safeParse(mappedReturn)

  if (!validatedReturn.success) {
    const formatted = formatZodError(validatedReturn.error, mappedReturn)
    console.error('Zod validation failed for ReturnsOrder:\n' + formatted)

    trackError(new Error('Zod validation failed'), {
      details: formatted,
      section: 'Returns'
    })

    throw new Error('Invalid ReturnsOrder data. See logs for details.')
  }
  return validatedReturn.data
}

export const toOrderNumber = (id: string | null) => (id || '').replace(/^#/, '')
